// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'


export const getLogsVehicles = createAsyncThunk('appUsers/getLogsVehicles', async params  => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/logs/vehicles', { params })
  
  return response.data

})
export const getLogsPerson = createAsyncThunk('appUsers/getLogsPerson', async params  => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/logs/persons', { params })
  
  return response.data

})
export const getArchivesLogsPerson = createAsyncThunk('appUsers/getArchivesLogsPerson', async params  => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/logs/archives/persons', { params })
  
  return response.data

})

export const getLogsWidgets = createAsyncThunk('appUsers/getLogsWidgets', async params  => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/logs/widgets', { params })
   
  return response.data

})

export const getLogSiteCamera = createAsyncThunk('appUsers/getLogSiteCamera', async params  => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/site/logs', { params })
  
  return response.data

})

export const getAllData = createAsyncThunk('appUsers/getAllData', async id  => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/all', { params: { id} })
  return response.data
})

export const addEventsSites = createAsyncThunk('appUsers/addEventsSites', async (event, { dispatch, getState }) => {

  await axios.post('https://apiv3.opentlv.com/api/v3/cameras/events/sites', event)

  return event
})


export const getAllDataCamera = createAsyncThunk('appUsers/getAllDataCamera', async id  => {
    const response = await axios.get('https://apiv3.opentlv.com/api/v3/camera', { params: { id} })
    
    return response.data

  })
  
  export const getData = createAsyncThunk('appUsers/getData', async params => {
    const response = await axios.get('https://apiv3.opentlv.com/api/v3/cameras/data', {params})
  
    return {
      params,
      data: response.data.data,
      totalPages: response.data.total
    }
  })
  export const getLogsExport = createAsyncThunk(
    'appUsers/getLogsExport',
    async params  => {
      try {
     
        const url = `https://apiv3.opentlv.com/api/v3/cameras/logs/export?_=${Date.now()}`
  
        // 2) Appel POST : 1er argument = data, 2ème = config
        const res = await axios.post(
          url,
          params,        
          {
            responseType: 'blob',
            headers: {
              // optionnel : forcer le serveur à renvoyer du binaire
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }
        )
  
        // 3) Création du blob et déclenchement du téléchargement
        const blob = new Blob(
          [res.data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        )
  
        const filename =
          res.headers['content-disposition']
            ?.match(/filename[^=\n]*=((['"]).*?\2|[^\n]*)/)?.[1]
            ?.replace(/['"]/g, '')
          || `export_${Date.now()}.xlsx`
  
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(link.href)
  
        return { success: true, filename }
      } catch (err) {
        console.error('ERROR DOWNLOAD FILE', err)
        return rejectWithValue(err.response?.data || err.message)
      }
    }
  )

export const getLogfsExport = createAsyncThunk('appUsers/getLogfsExport', async params  => {
  try {

    const cacheBuster = { _: Date.now() }
  const res = await axios.post('https://apiv3.opentlv.com/api/v3/cameras/logs/export', { params, responseType: 'blob'})
  
  const blob = new Blob(
    [res.data],
    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
  )

  /* 3) Nom du fichier (via Content‑Disposition si présent) */
  const filename =
    res.headers['content-disposition']?.match(/filename[^=\n]*=((['"]).*?\2|[^\n]*)/)?.[1]
      ?.replaceAll(/['"]/g, '') ||
    `export_${Date.now()}.xlsx`

  /* 4) Lance le téléchargement */
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)

  return { success: true, filename }
} catch (err) {
  console.log('ERROR DOWNLAOD FILE')
  return rejectWithValue(err.response?.data || err.message)
}
//return response.data

})
  export const addGare = createAsyncThunk('appUsers/addGare', async (gare, { dispatch, getState }) => {

    await axios.post('https://apiv3.opentlv.com/sncf/addgare', gare)
  
    await dispatch(getDataChannelsClient(getState().sitesClient.params))
    return gare
  })
  

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    camera: [],
    logs : [],
    vehiclesLogs: [],
    vehiclesCorrespondant : [],
    vehiclesArchives : [],
    personsLogs : [],
    granularity : null, 
    widgetsLogsVehicles : [],
    widgetsLogsPersons : [],
    personsLogsArchives : [],
    widgetsLogsGran : null,
    vacances : [],
    site : [],
    exportStatus: 'idle',   // 'idle' | 'loading' | 'succeeded' | 'failed'
    exportError: null,
    lastExport: null        // nom du dernier fichier téléchargé (optionnel)


  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataCamera.fulfilled, (state, action) => {
        state.camera = action.payload
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getLogsWidgets.fulfilled, (state, action) => {
        state.widgetsLogsVehicles = action.payload.widgetVehicles
        state.widgetsLogsPersons = action.payload.widgetPersons
        state.widgetsLogsGran = action.payload.granularity
        
 
      })
      .addCase(getLogsExport.fulfilled, (state, action) => {
        state.exportStatus = 'succeeded'
        state.lastExport   = action.payload?.filename || null
      })
      
      .addCase(getLogSiteCamera.fulfilled, (state, action) => {
        state.logs = action.payload.logs
        state.site =  action.payload.site
        state.vacances = action.payload.vacances
      })
      .addCase(getLogsVehicles.fulfilled, (state, action) => {
        state.vehiclesLogs = action.payload.vehiclesLogs
        state.granularity = action.payload.granularity
        state.vehiclesCorrespondant = action.payload.vehiclesCorrespondant
        state.vehiclesArchives = action.payload.vehiclesArchives
      })
      .addCase(getLogsPerson.fulfilled, (state, action) => {
        state.personsLogs = action.payload.personsLogs
        state.personsLogsArchives = action.payload.personsLogsArchives
        state.vacances = action.payload.vacances
        
      })
      .addCase(getArchivesLogsPerson.fulfilled, (state, action) => {
        state.personsTranches = action.payload.personsLog
        state.personsTranchesCorr = action.payload.personsLogCorr

      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
  }
})

export default appUsersSlice.reducer